import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingFreelancer.css";

export default function FreelancerLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing freelancer-landing">

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="logo-img"
          />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>

          <a href="#why" onClick={() => setMenuOpen(false)}>
            Why Nessefy
          </a>

          <a href="#how" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>

          <a href="#community" onClick={() => setMenuOpen(false)}>
            Community
          </a>

        </div>

        <div className="nav-actions">

          <button
            className="nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

      </nav>


      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="hero freelancer-hero">

        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">

          <p className="hero-badge">
            💼 BUILT FOR FREELANCERS WHO WANT TO GROW
          </p>

          <h1>
            Your Next
            <br />
            Opportunity
            <br />

            <span className="highlight">
              Is Out There.
            </span>
          </h1>

          <p>
            Discover clients, projects, collaborators and business
            opportunities that match your skills, interests and ambitions.
            Build your professional network on Nessefy.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-btn"
              onClick={goToRegister}
            >
              💼 Find My Opportunities
              <span className="button-arrow">→</span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="free-points">

            <span>
              <b>✓</b> 100% free to join
            </span>

            <span>
              <b>✓</b> No credit card
            </span>

            <span>
              <b>✓</b> Built for professionals
            </span>

          </div>

        </div>


        {/* =====================================================
            HERO VISUAL
        ===================================================== */}

        <div className="hero-card freelancer-hero-card">

          <div className="floating-mini-card mini-card-1">

            <h4>
              💼 New Opportunity
            </h4>

            <p>
              Find projects that fit your skills
            </p>

          </div>

          <div className="post-card freelancer-post-card">

            <div className="freelancer-network">

              <div className="network-circle network-one">
                👨🏻‍💻
              </div>

              <div className="network-circle network-two">
                👩🏻‍🎨
              </div>

              <div className="network-circle network-three">
                👨🏽‍💼
              </div>

              <div className="network-line line-one"></div>
              <div className="network-line line-two"></div>
              <div className="network-line line-three"></div>

              <div className="network-center">

                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />

              </div>

            </div>


            <div className="post-card-copy">

              <h3>
                Find Your Next Opportunity.
              </h3>

              <p>
                Your skills deserve to be discovered by the right people.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FREE STRIP
      ===================================================== */}

      <section className="free-strip">

        <div className="free-strip-icon">
          ✓
        </div>

        <div>

          <strong>
            Joining Nessefy is completely free.
          </strong>

          <span>
            Create your profile, showcase your skills and start
            discovering opportunities. No subscription. No joining fee.
          </span>

        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =====================================================
          SHOWCASE
      ===================================================== */}

      <section className="showcase">

        <div className="showcase-content">

          <span className="showcase-tag">
            FIND YOUR NEXT OPPORTUNITY
          </span>

          <h2>

            Stop chasing
            <br />
            opportunities.
            <br />

            <span className="showcase-highlight">
              Start discovering them.
            </span>

          </h2>

          <p>
            Nessefy brings freelancers, entrepreneurs, businesses,
            founders and professionals into one ecosystem.
            Discover people who need your skills and opportunities
            that can help you grow.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>

          <div className="showcase-benefits">

            <div>

              <span>
                01
              </span>

              <strong>
                Showcase
              </strong>

              <p>
                Create a profile that highlights your skills,
                experience and what you can offer.
              </p>

            </div>


            <div>

              <span>
                02
              </span>

              <strong>
                Discover
              </strong>

              <p>
                Find clients, businesses, projects and people
                looking for skills like yours.
              </p>

            </div>


            <div>

              <span>
                03
              </span>

              <strong>
                Connect
              </strong>

              <p>
                Start meaningful conversations and turn
                professional connections into opportunities.
              </p>

            </div>

          </div>

        </div>


        {/* =====================================================
            PHONE
        ===================================================== */}

        <div className="phone-showcase">

          <div className="floating-ui ui-top-left">
            💼 New Project
          </div>

          <div className="floating-ui ui-top-right">
            🚀 Grow Your Network
          </div>

          <div className="floating-ui ui-bottom-left">
            ⭐ Showcase Your Skills
          </div>

          <div className="floating-ui ui-bottom-right">
            ✨ Free to Join
          </div>


          <div className="phone-frame">

            <div className="phone-notch"></div>

            <div className="phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY SECTION
      ===================================================== */}

      <section
        id="why"
        className="features"
      >

        <div className="features-header">

          <span className="features-tag">
            WHY FREELANCERS JOIN NESSEFY
          </span>

          <h2>
            Your skills can
            <br />
            take you further.
          </h2>

          <p>
            Finding clients and opportunities shouldn't mean sending
            endless cold messages or competing on crowded platforms.
            Nessefy helps you build relationships and get discovered
            inside a professional ecosystem.
          </p>

        </div>


        <div className="journey-container">

          <div className="journey-card">

            <div className="journey-step">
              01
            </div>

            <div className="journey-icon">
              🎯
            </div>

            <h3>
              Showcase
            </h3>

            <p>
              Build a professional profile that clearly communicates
              your skills, experience and what you can offer.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card featured-journey">

            <div className="journey-step">
              02
            </div>

            <div className="journey-icon">
              🔎
            </div>

            <h3>
              Discover
            </h3>

            <p>
              Explore businesses, founders and professionals
              looking for people with your skills.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card">

            <div className="journey-step">
              03
            </div>

            <div className="journey-icon">
              🚀
            </div>

            <h3>
              Grow
            </h3>

            <p>
              Turn conversations into projects, collaborations,
              clients and long-term professional relationships.
            </p>

          </div>

        </div>


        <div className="features-stats">

          <div>

            <h4>
              FREE
            </h4>

            <p>
              Join Nessefy
            </p>

          </div>


          <div>

            <h4>
              AI
            </h4>

            <p>
              Smarter discovery
            </p>

          </div>


          <div>

            <h4>
              1
            </h4>

            <p>
              Professional ecosystem
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          HOW IT WORKS
      ===================================================== */}

      <section
        id="how"
        className="about"
      >

        <div className="about-content">

          <span className="about-tag">
            HOW IT WORKS
          </span>

          <h2>

            From
            <br />

            “I need more clients”

            <br />

            to

            <span className="how-highlight">
              “Let's work together.”
            </span>

          </h2>

          <p>
            You don't have to spend your day searching for work.
            Build your professional presence, tell people what you
            do and discover opportunities through Nessefy.
          </p>


          <div className="about-points">

            <div>

              <h4>
                01 — Create your profile
              </h4>

              <p>
                Showcase your skills, experience, services,
                interests and the type of opportunities you want.
              </p>

            </div>


            <div>

              <h4>
                02 — Get discovered
              </h4>

              <p>
                Put your professional profile in front of
                entrepreneurs, businesses and other professionals.
              </p>

            </div>


            <div>

              <h4>
                03 — Start connecting
              </h4>

              <p>
                Talk to the right people, understand their needs
                and turn connections into real opportunities.
              </p>

            </div>

          </div>

        </div>


        {/* =====================================================
            VISUAL
        ===================================================== */}

        <div className="about-visual">

          <div className="orbit-card about-card-1">
            Developer
          </div>

          <div className="orbit-card about-card-2">
            Designer
          </div>

          <div className="orbit-card about-card-3">
            Writer
          </div>

          <div className="orbit-card about-card-4">
            Marketer
          </div>

          <div className="orbit-card about-card-5">
            Consultant
          </div>


          <div className="about-center-card freelancer-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Show Your Skills
            </h3>

            <p>
              Skills • Experience • Opportunity
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMMUNITY
      ===================================================== */}

      <section
        id="community"
        className="community-section"
      >

        <div className="community-content">

          <span className="community-tag">
            A COMMUNITY OF PROFESSIONALS
          </span>

          <h2>

            Your next client,
            <br />

            collaborator or opportunity
            <br />

            could be one connection away.

          </h2>

          <p>
            Nessefy brings together freelancers, entrepreneurs,
            founders, businesses, investors and professionals who
            want to work, collaborate and grow together.
          </p>


          <div className="community-people">

            <div className="community-avatar">
              👨🏻‍💻
            </div>

            <div className="community-avatar">
              👩🏻‍🎨
            </div>

            <div className="community-avatar">
              👨🏽‍💼
            </div>

            <div className="community-avatar">
              👩🏽‍💻
            </div>

            <div className="community-avatar">
              👨🏻‍🚀
            </div>

            <div className="community-count">
              +
            </div>

          </div>


          <div className="community-labels">

            <span>
              Freelancers
            </span>

            <span>
              Entrepreneurs
            </span>

            <span>
              Founders
            </span>

            <span>
              Businesses
            </span>

            <span>
              Professionals
            </span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section
        className="contact-section final-freelancer-cta"
      >

        <div className="contact-content">

          <span className="contact-tag">
            YOUR NEXT OPPORTUNITY
          </span>

          <h2>

            Stop chasing
            <br />

            opportunities
            <br />

            everywhere.

          </h2>

          <h3>

            Start discovering them on

            <span>
              Nessefy.
            </span>

          </h3>

          <p>
            Join for free. Create your professional profile.
            Showcase what you do and start connecting with people
            who could help you grow.
          </p>


          <button
            className="primary-btn final-cta-button"
            onClick={goToRegister}
          >

            💼 Start My Freelance Journey

            <span>
              — It's Free
            </span>

          </button>


          <div className="final-free-line">

            ✓ Free to join

            <span>
              •
            </span>

            ✓ No credit card

            <span>
              •
            </span>

            ✓ Takes less than 2 minutes

          </div>

        </div>


        <div className="contact-card final-free-card">

          <div className="free-card-icon">
            ✓
          </div>

          <span>
            NO CATCH.
          </span>

          <h3>

            Nessefy is

            <br />

            <strong>
              100% FREE
            </strong>

            <br />

            to join.

          </h3>

          <p>
            Create your professional profile and start
            discovering people, projects and opportunities.
          </p>

          <button
            onClick={goToRegister}
            className="free-card-button"
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}

      <footer className="footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="footer-links">

          <span
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>

          <span
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}